import React from "react";
import PropType from "prop-types";

import {
  ArticleSliderAuthor,
  ArticleSliderDescription,
  ArticleSliderLink,
  ArticleSliderTitle,
  ArticleSliderItem,
} from "./styles";

import AwesomeSlider from "react-awesome-slider";
import withAutoplay from "react-awesome-slider/dist/autoplay";
import "react-awesome-slider/dist/styles.css";
import "./ArticleSlider.css";

export default function ArticleSlider(props) {
  const AutoplaySlider = withAutoplay(AwesomeSlider);

  return (
    <>
      <AutoplaySlider
        bullets={false}
        className="hero-slider"
        play={true}
        cancelOnInteraction={false}
        interval={8000}
      >
        {props.articles.map((article, index) => {
          return (
            <ArticleSliderLink href={article.endpoint} key={index}>
              <ArticleSliderItem.Container image={article.imageUrl}>
                <ArticleSliderDescription>
                  <ArticleSliderTitle href={article.endpoint}>
                    {article.title}
                  </ArticleSliderTitle>
                  <ArticleSliderAuthor>
                    Posted on {article.createdOn} by {article.author.fullName}
                  </ArticleSliderAuthor>
                </ArticleSliderDescription>
              </ArticleSliderItem.Container>
            </ArticleSliderLink>
          );
        })}
      </AutoplaySlider>
    </>
  );
}

ArticleSlider.propTypes = {
  articles: PropType.arrayOf(PropType.node).isRequired,
};
